import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import _ from 'lodash'
import { isPayBy, isToTok, isBOTIM } from 'utils'
import { queryIapConfig } from 'store/siteConfig'

// ------------------------------------
// Constants
// ------------------------------------
export const _CHECKOUT = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  GET_PAYMETHODS_REQUEST: null,
  GET_PAYMETHODS_SUCCESS: null,
}, '_CHECKOUT')

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  return (dispatch, getState) => {
    data.payerInfoFlag = true
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/cashdesk/queryTradeOrderDetail',
        requestAction: _CHECKOUT.INIT_REQUEST,
        successAction: _CHECKOUT.INIT_SUCCESS,
        success: function(result) {
          if (result.tradeStatus === 'S') {
            dispatch(replace('/error?msg=Order%20has%20been%20paid'))
          }
          sessionStorage.setItem('returnUrl', result.returnUrl)
        }
      })
    )
  }
}

export function getPayMethods(data) {
  return dispatch => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        endpoint: 'cgs/cashdesk/u/loadPayMethod',
        requestAction: _CHECKOUT.GET_PAYMETHODS_REQUEST,
        successAction: _CHECKOUT.GET_PAYMETHODS_REQUEST,
        success: function(result) {
          // 临时方法， 构建Message Pay的数据格式
          if (result.messagePayFlag) {
            const payMethods = _.chain(result)
              .get('paymentMethodList', [])
              .push({ type: 'message_pay', supportFlag: true })
              .value()
            dispatch({
              type: _CHECKOUT.GET_PAYMETHODS_SUCCESS,
              payload: {
                paymentMethodList: payMethods,
              },
            })
          } else {
            dispatch({
              type: _CHECKOUT.GET_PAYMETHODS_SUCCESS,
              payload: result,
            })
            if (!isPayBy() && !isToTok() && !isBOTIM()) {
              dispatch(queryIapConfig(data.token))
            }
          }
        },
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [_CHECKOUT.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [_CHECKOUT.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [_CHECKOUT.GET_PAYMETHODS_REQUEST]: (state, action) => state,
  [_CHECKOUT.GET_PAYMETHODS_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: true
}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'checkout',
    reducerMap: {
      checkoutState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
